module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/new-game/new-game.component.css
// module id = ./src/app/web/game/new-game/new-game.component.css
// module chunks = main